import { render, staticRenderFns } from "./selectImage.vue?vue&type=template&id=4e856b7c&scoped=true"
import script from "./selectImage.vue?vue&type=script&lang=js"
export * from "./selectImage.vue?vue&type=script&lang=js"
import style0 from "./selectImage.vue?vue&type=style&index=0&id=4e856b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e856b7c",
  null
  
)

export default component.exports